import React from "react";
import { ArrowUpRight, Calendar, Orbit, ShieldAlert, Users } from "lucide-react";

type Capability = {
  number: string;
  label: string;
  title: string;
  text: string;
  icon: React.ComponentType<{ className?: string }>;
  tone: "cyan" | "green" | "amber" | "blue";
};

const CAPABILITIES: Capability[] = [
  {
    number: "01",
    label: "Coordinate mesh",
    title: "The 4D Interactive Coordinate Mesh",
    text: "Rotate, zoom, and navigate the solar system with real-time vector raycasting and color-coded aspect geometry.",
    icon: Orbit,
    tone: "cyan",
  },
  {
    number: "02",
    label: "Entity projection",
    title: "Multi-party Entity Projection & Personas",
    text: "Inject people, companies, projects, and deal dates into a private spatial context.",
    icon: Users,
    tone: "green",
  },
  {
    number: "03",
    label: "Tactical readings",
    title: "Eye in the Sky Live Tactical Readings",
    text: "Evidence-grounded readings that turn exact mathematical orbs into clear behavioral reflection.",
    icon: ShieldAlert,
    tone: "amber",
  },
  {
    number: "04",
    label: "Temporal scrubbing",
    title: "Astro-Chronos 4D Temporal Scrubbing",
    text: "Move through time, compare configurations, intersect calendar context, and preserve the record.",
    icon: Calendar,
    tone: "blue",
  },
];

export const CapabilitiesSection: React.FC = () => (
  <section id="capabilities" className="landing-capabilities-section landing-reveal-section">
    <div className="landing-capabilities__inner">
      <header className="landing-capabilities__header">
        <span className="landing-section-kicker">[ Core Capabilities ]</span>
        <h2>Engineered for High-Agency Decision Makers</h2>
      </header>
      <div className="landing-capabilities-grid">
        {CAPABILITIES.map(({ number, label, title, text, icon: Icon, tone }) => (
          <article className={`landing-feature-card is-${tone}`} key={title}>
            <div className="landing-feature-card__topline">
              <span>{number}</span>
              <Icon aria-hidden="true" />
            </div>
            <div className="landing-feature-card__body">
              <span className="landing-feature-card__label">{label}</span>
              <h3>{title}</h3>
              <p>{text}</p>
            </div>
            <div className="landing-feature-card__footer" aria-hidden="true">
              <span>Instrument {number}</span>
              <ArrowUpRight />
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
